/**
 * Signatures of a dynamic import that hit a purged/stale chunk after a deploy.
 * Used by retryImport (src/utils/routeUtils.tsx) to trigger the auto-reload
 * guard, and by main.tsx's Sentry filter: by the time one of these propagates,
 * the reload guard has already given up, and that is exactly the state we need
 * visible in Sentry (HOK-OS-4W) — Chrome's variant would otherwise be
 * swallowed by the 'Failed to fetch' network-noise entries.
 */
export const STALE_CHUNK_SIGNATURES = [
  'Failed to fetch dynamically imported module', // Chrome
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari
  'is not a valid JavaScript MIME type', // Safari 26: HTML served at a chunk URL
];

export function isStaleChunkError(message: string): boolean {
  return STALE_CHUNK_SIGNATURES.some((sig) => message.includes(sig));
}
